import React, { Suspense, useEffect, useState, useRef } from "react";
import { Route, Routes } from "react-router-dom";
import { Loader } from "./components/Loader";
import { RouteConfig } from "./RouteConfig";
import PageReference from "./class/PageReference";
import Constant from "./Constant";
import "./App.scss";
import "./MediaScreens.scss";
import { AppContext } from "./context/AppContext";

interface IAppProps { match: any }

const App: React.FC<IAppProps> = ({ match }) => {

  const [responsiveWidth, setResponsiveWidth] = useState(0);
  const componentShouldUpdate = useRef(false);
  const pageReference = useRef<PageReference[]>([]);
  const isMobileView = window.innerWidth < Constant.MaxMobileWidth;

  const showLoader = (show: boolean) => {
    const loader = document.getElementById("preloader") as any;
    loader.className = show ? "preloader" : "preloaded";
  }
  useEffect(() => {
    const responsiveScreenWidth: number[] = [490, 930, 1279];
    const handleResize = () => {
      updateResponsiveWidth();
      resize();
    };

    const resize = () => {
      const newResponsiveWidth = responsiveScreenWidth.filter((width) => window.innerWidth <= width)[0] ?? 0;
      if (responsiveWidth !== newResponsiveWidth) {
        componentShouldUpdate.current = true;
        setResponsiveWidth(newResponsiveWidth);
        window.scrollTo(0, 0);
      }
    };

    const updateResponsiveWidth = () => {
      const newResponsiveWidth = responsiveScreenWidth.filter(
        (width) => window.innerWidth <= width
      )[0];
      setResponsiveWidth(newResponsiveWidth || 0);
    };

    window.addEventListener("resize", handleResize);

    updateResponsiveWidth();
    setTimeout(() => showLoader(false), 1500);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [responsiveWidth]);


  if (isMobileView && window.location.href.split("/").length > 4) {
    window.location.href = window.location.host;
  }

  const updatePageReference = (params: { hash: string, ref: any }) => {
    if (!pageReference.current.find((p) => p.hash === params.hash))
      pageReference.current.push({ hash: params.hash, ref: params.ref });
  };

  const navigate = (hash: string) => {
    const target = pageReference.current.find((p) => p.hash === hash);
    if (target) {
      const element = document.getElementById(target.hash.split("#")[1]);
      if (element) {
        window.scrollTo({
          top: element.offsetTop,
          left: 0,
          behavior: "smooth",
        });
      }
    }
  }

  return (<AppContext.Provider value={{
    isMobileView,
    setLoader: (value) => showLoader(value),
    updatePageReference,
    navigate: navigate
  }}>
    <div className="app" onContextMenu={(e: React.MouseEvent) => e.preventDefault()}>
      <Suspense fallback={<Loader />}>
        <Routes>
          {RouteConfig.map((component, i) => (
            <Route
              key={i}
              path={component.path}
              element={
                <Suspense fallback={null}>
                  <component.component key={i} match={match} />
                </Suspense>
              }
            />
          ))}
        </Routes>
      </Suspense>
    </div>
  </AppContext.Provider>
  );
};

export default App;